import { render } from "./CollateralCard.vue?vue&type=template&id=f22048ce&scoped=true"
import script from "./CollateralCard.vue?vue&type=script&lang=js"
export * from "./CollateralCard.vue?vue&type=script&lang=js"

import "./CollateralCard.vue?vue&type=style&index=0&id=f22048ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22048ce"]])

export default __exports__